export default {
    // Menu Roles y Permisos
    id: '1',
    routeName: "default",//Ruta por default
    interface: 'b2b.store',
    label: 'Tienda',
    isInterface: true,
    items: [
        // Catalog
        {
            id: '1.1',
            label: 'Tienda',
            icon: "bx bx-store",
            permissions: ['b2b.store_client'],
            routeName: 'store.store',
            isTitle: true,
            selected: false,
            subItems: [
                {
                    id: '1.1.1',
                    label: 'Cátalogo',
                    permission: 'system_users_list',
                    routeName: "store.store",
                    show: false
                },
                {
                    id: '1.1.2',
                    label: 'Carrito',
                    permission: 'system_users_create',
                    routeName: "store.store.cart",
                    show: false
                },
                {
                    id: '1.1.3',
                    label: 'Confirmación',
                    permission: 'system_users_edit',
                    routeName: "store.store.confirm",
                    show: false
                }

            ]
        },
        // Mis pedidos
        {
            id: '1.2',
            label: 'Mis Pedidos',
            icon: 'bx bx-package',
            permissions: ['b2b.store_client', 'b2b.store_admin'],
            isTitle: true,
            selected: true,
            subItems: [
                {
                    id: '1.2.1',
                    label: 'Mis Pedidos',
                    routeName: "store.orders",
                    // permission: 'system_roles_create',
                    show: true,
                },
                {
                    id: '1.2.2',
                    label: 'Información Pedido',
                    routeName: "store.orders.view",
                    // permission: 'system_roles_create',
                    show: false,
                },
                {
                    id: '1.2.3',
                    label: 'Mis Pagos',
                    routeName: "store.finance.credit",
                    // permission: 'b2b.store_admin',
                    show: true,
                },
                {
                    id: '1.2.4',
                    label: 'Mis Facturas',
                    routeName: "store.finance.invoice",
                    // permission: 'b2b.store_admin',
                    show: true,
                },
                {
                    id: '1.2.5',
                    label: 'Mis Devoluciones',
                    routeName: "store.orders.returns",
                    // permission: 'b2b.store_admin',
                    show: true,
                },
                {
                    id: '1.2.6',
                    label: 'Mi Wallet',
                    routeName: "store.finance.wallet",
                    // permission: 'b2b.store_admin',
                    show: true,
                },
            ]
        },
        // Mi cuenta
        {
            id: '1.4',
            label: 'Mi Cuenta',
            icon: 'bx bx-id-card',
            permissions: ['b2b.store_client'],
            routeName: "store.account",
            selected: true,
            subItems: [
                {
                    id: '1.4.1',
                    label: 'Información General',
                    // permission: 'system_roles_list',
                    routeName: "store.account",
                    show: false
                },
            ]
        },
        // Notificaciones
        // {
        //     id: '1.5',
        //     label: 'Notificaciones',
        //     icon: 'bx bx-bell',
        //     permissions: ['b2b.store_client'],
        //     routeName: "store.account",
        //     selected: true,
        //     subItems: [
        //         {
        //             id: '1.4.1',
        //             label: 'Información General',
        //             // permission: 'system_roles_list',
        //             routeName: "store.account",
        //             show: false
        //         },
        //     ]
        // },
        // Preguntas Frecuentes
        // {
        //     id: '1.6',
        //     label: 'Preguntas Frecuentes',
        //     icon: 'bx bx-question-mark',
        //     permissions: ['b2b.store_client'],
        //     routeName: "store.account",
        //     selected: true,
        //     subItems: [
        //         {
        //             id: '1.4.1',
        //             label: 'Información General',
        //             // permission: 'system_roles_list',
        //             routeName: "store.account",
        //             show: false
        //         },
        //     ]
        // },
        // Notificaciones
        // {
        //     id: '1.7',
        //     label: 'Contacto',
        //     icon: 'bx bxs-phone-call',
        //     permissions: ['b2b.store_client'],
        //     routeName: "store.account",
        //     selected: true,
        //     subItems: [
        //         {
        //             id: '1.4.1',
        //             label: 'Información General',
        //             // permission: 'system_roles_list',
        //             routeName: "store.account",
        //             show: false
        //         },
        //     ]
        // },
    ]
} 